"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getTicketsAssociationsOptions;

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _AssociationOptionsDependencyHelpers = require("crm_data/associations/AssociationOptionsDependencyHelpers");

var _EngagementAssociationsConstants = require("crm_data/associations/EngagementAssociationsConstants");

var _TicketsSearchAPIQuery = _interopRequireDefault(require("crm_data/tickets/api/TicketsSearchAPIQuery"));

var _immutable = require("immutable");

var _TicketsStore = _interopRequireDefault(require("crm_data/tickets/TicketsStore"));

function getAlreadyAssociatedTickets(values) {
  var ticketIds = (0, _AssociationOptionsDependencyHelpers.getIdsFromOptions)(values, 'ticketValues');
  var alreadyAssociatedTickets = ticketIds ? _TicketsStore.default.get(ticketIds) : (0, _immutable.List)();
  return (0, _AssociationOptionsDependencyHelpers.parseMatches)(alreadyAssociatedTickets);
}

function getTicketsAssociationsOptions(_ref) {
  var objectType = _ref.objectType,
      subjectId = _ref.subjectId,
      subject = _ref.subject,
      state = _ref.state,
      values = _ref.values;
  var debouncedSearchTextForElasticSearch = state.debouncedSearchTextForElasticSearch;
  var alreadyAssociatedTickets = getAlreadyAssociatedTickets(values);
  var ticketOptions = [];

  if (objectType === _ObjectTypes.TICKET) {
    ticketOptions = (0, _AssociationOptionsDependencyHelpers.parseMatches)((0, _immutable.List)([subject]));
  } else {
    ticketOptions = (0, _AssociationOptionsDependencyHelpers.getAssociationsFromAssociationsStore)(objectType, subjectId, objectType + "_TO_TICKET", _ObjectTypes.TICKET);

    if (ticketOptions && ticketOptions.length > _EngagementAssociationsConstants.ASSOC_STORE_SEARCH_MAX && (0, _AssociationOptionsDependencyHelpers.hasMinimumSearchText)(debouncedSearchTextForElasticSearch)) {
      var query = _TicketsSearchAPIQuery.default.associatedTickets(objectType, subjectId, _EngagementAssociationsConstants.MAX_OPTION_SIZE, debouncedSearchTextForElasticSearch);

      ticketOptions = (0, _AssociationOptionsDependencyHelpers.getAssociationsFromElasticSearch)(subjectId, query, _ObjectTypes.TICKET);
    }
  }

  var allTicketOptions = (0, _immutable.List)(alreadyAssociatedTickets.concat(ticketOptions || [])).reduce(function (map, option) {
    return map.set(option.id, option);
  }, (0, _immutable.Map)()).sortBy(function (match) {
    return match.text.toLowerCase();
  }).toArray();
  return allTicketOptions;
}

module.exports = exports.default;